import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-e2a92694"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务管理", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务列表", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "广告位", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "广告位列表", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "广告合约", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "合约列表", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实名认证", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实名认证列表", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "支付", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "支付记录", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信待签约", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商户列表", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Help = _resolveComponent("Help")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu, {
        router: "",
        "unique-opened": "",
        collapse: _ctx.isShow,
        "default-active": _ctx.route.path
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/",
            class: "logo"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "3" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Help)
                ]),
                _: 1
              }),
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/collaborate/service" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Help)
                    ]),
                    _: 1
                  }),
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "6" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Help)
                ]),
                _: 1
              }),
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/collaborate/advertisement" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Help)
                    ]),
                    _: 1
                  }),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "2" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Help)
                ]),
                _: 1
              }),
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/collaborate/Adcontract" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Help)
                    ]),
                    _: 1
                  }),
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "4" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Help)
                ]),
                _: 1
              }),
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/collaborate/rnauthentication" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Help)
                    ]),
                    _: 1
                  }),
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "5" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Help)
                ]),
                _: 1
              }),
              _hoisted_10
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/collaborate/payment" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Help)
                    ]),
                    _: 1
                  }),
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "7" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Help)
                ]),
                _: 1
              }),
              _hoisted_12
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/collaborate/wx" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Help)
                    ]),
                    _: 1
                  }),
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["collapse", "default-active"])
    ]),
    _: 1
  }))
}